import React, { Component } from "react";
import Header from "../../../layout/header";
import Footer from "../../../layout/footer";
import MetaTags from "../../../element/MetaTags";
import LocationSidebar from "../components/LocationSidebar";

const bg = require("../../../../images/servicehero.png");

class HouseCleaningBrisbane extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="House Cleaning Brisbane | Professional Home Cleaners"
          description="Reliable house cleaning Brisbane. Weekly, deep and move in cleaning services by professional cleaners."
          keywords="house cleaning brisbane, cleaning services brisbane, residential cleaning brisbane, home cleaning brisbane, domestic cleaning brisbane, weekly house cleaning brisbane, fortnightly cleaning brisbane, deep cleaning brisbane, move in cleaning brisbane, move out cleaning brisbane, apartment cleaning brisbane, unit cleaning brisbane, professional house cleaners brisbane, affordable house cleaning brisbane, same day house cleaning brisbane, eco friendly cleaning brisbane, sanitisation cleaning brisbane, kitchen cleaning brisbane, bathroom cleaning brisbane, floor mopping brisbane, carpet vacuuming brisbane, one off cleaning brisbane, reliable cleaners brisbane, trusted cleaning company brisbane, house cleaning near me brisbane, relocation cleaning brisbane, rental cleaning brisbane, property cleaning brisbane, high rise apartment cleaning brisbane, local cleaners brisbane"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">
                  Professional House Cleaning Brisbane
                </h1>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <div className="col-xl-3 col-lg-4 col-md-5">
                    <LocationSidebar activePage="/house-cleaning-brisbane/" />
                  </div>
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className="col-md-12 m-b30">
                      <div className="dlab-box">
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            Professional House Cleaning Brisbane
                          </h4>
                          <p>
                            Keeping your home clean in a busy city like Brisbane
                            can be challenging. Our house cleaning Brisbane
                            service provides reliable and thorough residential
                            cleaning tailored to your schedule and needs.
                          </p>
                          <p>
                            Kangaroo Shine Property Services delivers
                            professional home cleaning solutions designed for
                            apartments, houses and rental properties across
                            Brisbane.
                          </p>

                          <h4 className="dlab-title m-t30">
                            Regular Residential Cleaning Brisbane
                          </h4>
                          <p>We offer flexible cleaning plans including:</p>
                          <ul className="list-check primary">
                            <li>Weekly cleaning</li>
                            <li>Fortnightly cleaning</li>
                            <li>Monthly maintenance cleaning</li>
                          </ul>

                          <h4 className="dlab-title m-t30">
                            Our regular cleaning includes:
                          </h4>
                          <ul className="list-check primary">
                            <li>Vacuuming carpets</li>
                            <li>Mopping hard floors</li>
                            <li>Cleaning bathrooms</li>
                            <li>Dusting surfaces</li>
                            <li>Wiping kitchen areas</li>
                          </ul>

                          <h4 className="dlab-title m-t30">
                            Deep House Cleaning Brisbane
                          </h4>
                          <p>
                            Our deep cleaning service is ideal for seasonal
                            refresh, after renovations or preparing for special
                            events.
                          </p>

                          <h4 className="dlab-title m-t30">
                            Move In and Move Out Cleaning Brisbane
                          </h4>
                          <p>
                            Relocating within Brisbane? Our move in and move out
                            cleaning services ensure properties are thoroughly
                            cleaned before inspection or settlement.
                          </p>

                          <h4 className="dlab-title m-t30">
                            Why Choose Kangaroo Shine in Brisbane
                          </h4>
                          <ul className="list-check primary">
                            <li>Experienced professional cleaners</li>
                            <li>Reliable scheduling</li>
                            <li>Competitive pricing</li>
                            <li>Eco friendly cleaning solutions</li>
                          </ul>

                          <h4 className="dlab-title m-t30">Service Areas</h4>
                          <p>Brisbane CBD and surrounding suburbs.</p>

                          <h4 className="dlab-title m-t30">
                            Book House Cleaning Brisbane Today.
                          </h4>
                          <p>
                            Contact us to schedule your next clean and
                            experience the Kangaroo Shine difference in
                            Brisbane.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default HouseCleaningBrisbane;
